import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbModalRef, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service'
import { ToastrService } from 'ngx-toastr';
import { ITBEditBidComponent } from '../itb-edit-bid/itb-edit-bid.component';
import { Router } from '@angular/router';
import { NgIf, NgFor, DecimalPipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { I18nModule } from '@spartacus/core';
@Component({
    selector: 'app-itb-edit-confirm-bid',
    templateUrl: './itb-edit-confirm-bid.component.html',
    styleUrls: ['./itb-edit-confirm-bid.component.scss'],
    imports: [NgIf, FormsModule, NgFor, DecimalPipe, DatePipe, I18nModule]
})
export class ITBEditConfirmBidComponent implements OnInit {
  private modalRef: NgbModalRef;
  COI: boolean = false;
  ITB: boolean = false;
  OpenNegotiation: boolean = true;
  @Input() datePeriod: any;
  @Input() priceshw: number;
  @Input() indexPriceshw: number;
  @Input() code: any;
  @Input() dischargePortshw: any;
  @Input() quantityshw: any;
  productInfo: any;
  product: any;
  biddingTerms = '';
  requestParams: any;
  requestTenders:any[]=[];
  enableLoader: boolean = false;
  confirmTxt: string = null;

  constructor(private customProductService: CustomProductsService, public activeModal: NgbActiveModal, private Modal: NgbModal, private router: Router,
    private customProductsService: CustomProductsService, private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.customProductsService.getConfirmtxt().subscribe((txt)=>{
      this.confirmTxt = txt;
    })
    this.product = this.datePeriod;
    // this.productInfo=this.code;
    this.biddingTerms = this.product ? this.product.buyerRemarks : '';
    console.log(this.product.buyerRemarks, 'bt')
    if (this.datePeriod?.combinedTenders.length == 1) {
      this.productInfo = this.code;
    } else {
      this.productInfo = this.code[0];
    }
    if (this.datePeriod.groupTenders) {
      this.datePeriod.combinedchildlist = [...this.productInfo.childList]
    }
    if (this.datePeriod.groupTenders == undefined) {
      this.requestParams = {
        "quoteAction": "EDIT_BID",
        "tender": {
          "quoteCode": this.product.quoteCode,
          "tenderEntries": [
            {
              "entryNumber": this.productInfo.entryNumber,
              "productCode": this.productInfo.productCode,
              "quantity": this.productInfo?.isQuantityUnrestricted == true ? this.quantityshw : this.productInfo.quantity,
              "dischargePortDetails": this.productInfo?.isDischargePortUnrestricted == true ? this.dischargePortshw : '',
              "qpMultipleChoices": this.productInfo.pricingOptionsEnum[0].qp,
              "rcPrice": {
                "currencyIso": "USD",
                "value": this.indexPriceshw
              },
              "tcPrice": {
                "currencyIso": "USD",
                "value": this.priceshw
              }
            }
          ]
        }
      }
    }
    else {
      this.datePeriod.combinedchildlist.map((val)=>{
        this.requestTenders.push({
                "entryNumber": val.entryNumber,
                "productCode": val.productCode,
                "quantity": val.isQuantityUnrestricted == true ? this.quantityshw : val.quantity,
                "dischargePortDetails": val.isDischargePortUnrestricted == true ? this.dischargePortshw : val.dischargePortshw,
                "qpMultipleChoices": this.productInfo.pricingOptionsEnum[0].qp,
                "rcPrice": {
                  "currencyIso": "USD",
                  "value": val.indexPriceshw
                },
                "tcPrice": {
                  "currencyIso": "USD",
                  "value": val.priceshw
                }
        })
      })
      

    }

  }
  submit(): any {
    console.log(this.requestParams);
    if(this.datePeriod.groupTenders){
      this.requestParams={
        "quoteAction": "EDIT_BID",
      "tender": {
        "buyerRemarks": this.biddingTerms,   
        "quoteCode": this.product.quoteCode,
        "tenderEntries": this.requestTenders
      }
    }
    } 
    //this.requestParams.tender.quoteEntries[0].relativePrice.value = parseFloat(price);
    this.requestParams.tender.buyerRemarks = this.biddingTerms;
    if(this.product.commodityType == 'CN'){
      this.requestParams.tender.tenderEntries[0].tcPrice.value = this.requestParams.tender.tenderEntries[0].tcPrice.value
      if(this.requestParams.tender.tenderEntries[0].rcPrice){
        this.requestParams.tender.tenderEntries[0].rcPrice.value = this.requestParams.tender.tenderEntries[0].rcPrice.value
      }
      if ( this.productInfo.displayRCPriceConfig.displayRCPrice == false) {
        delete this.requestParams.tender.tenderEntries[0].rcPrice
      }
    }
   
    //console.log(this.requestParams);
    this.enableLoader = true;
    this.customProductsService.submitTender(this.requestParams).subscribe(resp => {
      console.log(resp);
      if (resp.status === "BID_PLACED") {
        //this.toastrService.show(resp.status);
        this.enableLoader = false;
        this.customProductService.bidPlaced = true;
        this.activeModal.close();
        const currentUrl = this.router.url;
        if (currentUrl === '/quotes/myquotes') {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([currentUrl]);
          });
        } else {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([currentUrl]);
          });
        }
      } else {
        this.enableLoader = false;
        this.toastrService.show(resp.status);
      }

    },
      err => {
        this.enableLoader = false;
        this.activeModal.close();
        this.toastrService.show(err?.error.errors?err.error.errors[0].message:'Something went wrong while submitting the tender, please contact support team');
      })

  }
  backToPlacebid(): any {
    this.activeModal.close();
    const ModalRef = this.Modal.open(ITBEditBidComponent, { centered: true, size: 'sm' });
    if (this.datePeriod?.combinedTenders.length == 1) {
      ModalRef.componentInstance.productsInfo = this.datePeriod;
      ModalRef.componentInstance.priceshw = this.priceshw;
      ModalRef.componentInstance.indexPriceshw = this.indexPriceshw;
      ModalRef.componentInstance.dischargePortshw = this.dischargePortshw;
      ModalRef.componentInstance.quantityshw = this.quantityshw;
      if(this.productInfo.pricingOptionsEnum[0]?.qp){
        ModalRef.componentInstance.defaultValue = this.productInfo?.pricingOptionsEnum[0]?.qp[0]?.description;
        if(ModalRef.componentInstance.defaultValue == 'Fixed QP'){
          ModalRef.componentInstance.displayFixedQPSection = true;
          ModalRef.componentInstance.finalQPFromDate= ModalRef.componentInstance.productInfo.finalQPFromDate;
          ModalRef.componentInstance.finalQPToDate= ModalRef.componentInstance.productInfo.finalQPToDate;
        }else{
          ModalRef.componentInstance.displayFixedQPSection = false;
        }
      }
    } else {
      ModalRef.componentInstance.selectProduct = this.datePeriod;
      ModalRef.componentInstance.productsEntry = this.code;
      ModalRef.componentInstance.priceshw = this.priceshw;
      ModalRef.componentInstance.indexPriceshw = this.indexPriceshw;
      if(this.productInfo.pricingOptionsEnum[0]?.qp){
        ModalRef.componentInstance.defaultValue = this.productInfo?.pricingOptionsEnum[0]?.qp[0]?.description;
        if(ModalRef.componentInstance.defaultValue == 'Fixed QP'){
          ModalRef.componentInstance.displayFixedQPSection = true;
          ModalRef.componentInstance.finalQPFromDate= ModalRef.componentInstance.selectProduct.finalQPFromDate;
          ModalRef.componentInstance.finalQPToDate= ModalRef.componentInstance.selectProduct.finalQPToDate;
        }else{
          ModalRef.componentInstance.displayFixedQPSection = false;
        }
      }
    }
   
    //   if(this.datePeriod.quoteEntries[0].pricingOptionsEnum[0].pricingOptions=='FIXED'){
    //     ModalRef.componentInstance.price=this.price;
    //   }
    //  if(this.datePeriod.quoteEntries[0].pricingOptionsEnum[0].pricingOptions=='INDEX'){
    //   ModalRef.componentInstance.indexPrice=this.price;
    //  }
  }
  getDate(date) {
    if(date){
      var formateDate = new Date(date).getDate() + '/' + (new Date(date).getMonth() + 1) + '/' + new Date(date).getFullYear();
      return formateDate;
    }
    else{
      return '';
    }

  }
  formatQPDates(data){
    return this.customProductService.formatQPDates(data);
  }

}
